import {connect} from "react-redux"
import State from "../../ducks/state"

export const mapStateToProps = (state: State) => {
    return {
        templating: state.template,
        displayTestTools: state.settings.showTestTools,
    }
}

export default connect(mapStateToProps)
